import { HelmetDexteel } from "@dexteel/mesf-core";
import { ReturnedRollsReport } from "./components/ReturnedRollsReport";

export const ReturnedRollsPage = () => {
	return (
		<>
			<HelmetDexteel title="Returned Rolls" />
			<ReturnedRollsReport />
		</>
	);
};
